<template>
  <StackLayout>
    <AgCaption :dark="dark" noMargin left v-if="caption.length > 0" :text="caption" />
    <ScrollView :orientation="scrollOrientation">
      <StackLayout class="wrapper" :orientation="wrapperOrientation">
        <slot name="default"></slot>
      </StackLayout>
    </ScrollView>
  </StackLayout>
</template>

<script>
import env from '@/helpers/env'

export default {
  props: {
    caption: {
      type: String,
      default: ''
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      windowWidth: env.isWeb ? window.innerWidth : 800
    }
  },
  computed: {
    scrollOrientation () {
      return this.isNarrowViewport ? 'vertical' : 'horizontal'
    },
    wrapperOrientation () {
      return this.isNarrowViewport ? 'vertical' : 'horizontal'
    },
    isNarrowViewport () {
      return this.windowWidth <= 768
    }
  },
  methods: {
    handleResize () {
      if (env.isWeb) {
        this.windowWidth = window.innerWidth
      }
    }
  },
  mounted () {
    if (env.isWeb) {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    }
  },
  beforeDestroy () {
    if (env.isWeb) {
      window.removeEventListener('resize', this.handleResize)
    }
  }
}

</script>

<style scoped lang="scss">

.wrapper::v-deep .animal.link {
  &:active .risks .icon,
  &.active .risks .icon {
    color: white;
  }
}

.ns-ios,
.ns-android {
  .caption {
    margin: 0 20 20 20;
  }

  .wrapper {
    padding: 0 10 20 20;

    &::v-deep .animal {
      margin-right: 10;

      .risks .icon {
        margin-left: 5;
      }
    }
  }
}

html {
  .caption {
    margin: 0 20px 20px 20px;
  }

  .wrapper {
    padding: 0 10px 20px 20px;
    width: fit-content;

    &::v-deep .animal {
      margin-right: 10px;

      .risks .icon {
        margin-left: 5px;
      }
    }
  }

  /* Responsive layout for mobile viewports (768px and below) */
  @media (max-width: 768px) {
    .wrapper {
      padding: 0 20px 20px 20px !important;
      width: 100% !important;

      &::v-deep .animal {
        margin-right: 0 !important;
        margin-bottom: 20px !important;
        width: 100% !important;
        min-width: unset !important;
      }

      &::v-deep .animal:last-child {
        margin-bottom: 0 !important;
      }
    }
  }

  @media (min-width: 769px) {
    .caption {
      margin-left: 40px;
      margin-right: 40px;
    }

    .wrapper {
      padding: 0 30px 40px 40px;

      &::v-deep .animal {
        margin-right: 20px;
        min-width: 240px;
      }
    }
  }
}

</style>
